import React from "react";

interface TopProductsSkeletonProps {
  /** Number of section rails to render (including the featured/large one). Defaults to 3. */
  sectionCount?: number;
  /** Number of skeleton cards per rail. Defaults to 6. */
  cardsPerRail?: number;
}

const Block: React.FC<{ className?: string }> = ({ className = "" }) => (
  <div
    className={`bg-gray-200 dark:bg-dark-700 rounded ${className}`}
  />
);

const Card: React.FC = () => (
  <div className="w-[168px] flex-shrink-0 rounded-2xl border border-gray-100 dark:border-dark-700 bg-white dark:bg-dark-800 overflow-hidden">
    <div className="aspect-square w-full bg-gray-100 dark:bg-dark-700" />
    <div className="px-2.5 pt-2 pb-3">
      <Block className="h-2.5 w-[90%]" />
      <Block className="h-2.5 w-[70%] mt-1.5" />
      <Block className="h-3.5 w-16 mt-2.5 rounded" />
      <Block className="h-2.5 w-11 mt-1.5" />
    </div>
  </div>
);

const Section: React.FC<{ large?: boolean; cards: number }> = ({ large, cards }) => (
  <div className={large ? "mt-2" : "mt-6"}>
    <div className={`flex items-end gap-3 px-4 mb-2.5 ${large ? "pt-5 mb-3.5" : ""}`}>
      <div className="flex-1 min-w-0">
        <Block className={large ? "h-5 w-56" : "h-4 w-40"} />
        <Block className="h-2.5 w-36 mt-2" />
      </div>
      <Block className="h-3 w-14" />
    </div>
    <div className="flex gap-2.5 px-4 pb-1.5 overflow-hidden">
      {Array.from({ length: cards }).map((_, i) => (
        <Card key={i} />
      ))}
    </div>
  </div>
);

const TopProductsSkeleton: React.FC<TopProductsSkeletonProps> = ({
  sectionCount = 3,
  cardsPerRail = 6,
}) => {
  return (
    <div className="w-full h-full overflow-hidden bg-gray-50 dark:bg-dark-950 animate-pulse">
      <Section large cards={cardsPerRail} />
      {Array.from({ length: Math.max(0, sectionCount - 1) }).map((_, i) => (
        <Section key={i} cards={cardsPerRail} />
      ))}
    </div>
  );
};

export default TopProductsSkeleton;
